export { ReusableTabsComponent } from '../components/reusable-tabs/reusable-tabs.component';
export type { TabConfig } from '../components/reusable-tabs/reusable-tabs.component';
export type { TabsConfiguration } from '../components/reusable-tabs/reusable-tabs.component';
